import { useEffect } from 'react';
import { onInternalChatNewMessage, onInternalChatMention } from '../services/realtimeService';
import { playNotify } from '../services/soundService';

/**
 * Dźwięk przy nowej wiadomości / wzmiance w czacie wewnętrznym.
 * Montowany w Layout (desktop) i MobileLayout — Header na mobile nie istnieje.
 * Pomija: tryb „nie przeszkadzać”, gdy panel czatu jest otwarty (window.__unitrescoChatOpen).
 */
export function useInternalChatNotifySound(isAuthenticated: boolean, isLoading: boolean): void {
  useEffect(() => {
    if (!isAuthenticated || isLoading) return;
    const shouldPlay = () => {
      try {
        if ((localStorage.getItem('chat:dnd') || '0') === '1') return false;
      } catch {
        return false;
      }
      try {
        if ((window as unknown as { __unitrescoChatOpen?: boolean }).__unitrescoChatOpen) return false;
      } catch {
        /* ok */
      }
      return true;
    };
    const off1 = onInternalChatNewMessage(() => {
      if (!shouldPlay()) return;
      try {
        void playNotify();
      } catch {
        /* autoplay policy */
      }
    });
    const off2 = onInternalChatMention(() => {
      if (!shouldPlay()) return;
      try {
        void playNotify();
      } catch {
        /* autoplay policy */
      }
    });
    return () => {
      try {
        (off1 as () => void)?.();
      } catch {
        /* ok */
      }
      try {
        (off2 as () => void)?.();
      } catch {
        /* ok */
      }
    };
  }, [isAuthenticated, isLoading]);
}
